import {gql, useQuery} from "@apollo/client";
import moment from "moment";
import event1Image from "../../../../../assets/img/demo/event1-image.png";
import ShadowScrollbars from "../../../../ui/custom_scrollbars/ShadowScrollbars";
import React, {useState} from "react";
import Loading from "../../../../ui/feedback/Loading";
import NoError from "../../../../ui/feedback/NoError";
import NoResultFound from "../../../../ui/feedback/NoResultFound";
import Events from "../Events";
import Image from "react-bootstrap/Image";
import {Col, Container, Row} from "react-bootstrap";
import Tools from "../../../../../Tools";

const MatchesEvents = props => {
    const query = gql`
        query getEvents(
            $q: String,
            $regions: [String!],
            $countries: [String!],
            $skip: Int,
            $take: Int
        ){
            events: getEvents(
                q: $q,
                regions: $regions,
                countries: $countries,
                skip: $skip,
                take: $take
            ){
                total
                filteredFrom
                results{
                    title
                    description
                    image
                    url
                    eventDate
                }
            }
        }
    `;
    // Get filters values from props.
    const {regions, countries, search: _q} = props;
    const [q, setQ] = useState(_q);

    // Delay search process.
    Tools.delay(() => setQ(_q), 500);

    const variables = {
        q: Tools.convertEmptyToNull(q),
        regions: Tools.convertEmptyToNull(regions),
        countries: Tools.convertEmptyToNull(countries),
        skip: 0,
        take: 12,
    };

    const formatter = (events) => {
        if (!events)
            return [];

        return events.map(event => {
            const formattedDate = moment().calendar((event.eventDate), {
                sameDay: '[Today] HH:mm',
                nextDay: '[Tomorrow] HH:mm',
                nextWeek: 'dddd HH:mm',
                sameElse: 'dddd DD/MM/YYYY HH:mm'
            });

            return {
                title: event.title,
                website: event.url,
                datetime: formattedDate,
                description: event.description,
                image: event.image
            };
        });
    };


    const {loading, error, data, fetchMore} = useQuery(query, {
        variables: variables,
        notifyOnNetworkStatusChange: true
    });

    const handleFetchMore = () => {
        fetchMore({
            variables: {
                q: Tools.convertEmptyToNull(q),
                regions: Tools.convertEmptyToNull(regions),
                countries: Tools.convertEmptyToNull(countries),
                skip: data?.events?.length ?? 0,
                take: 12,
            },
            updateQuery: (prev, {fetchMoreResult}) => {
                if (!fetchMoreResult) return prev;
                return Object.assign({}, prev, {
                    events: [...prev.events, ...fetchMoreResult.events]
                });
            }
        });
    };

    if (error) {
        return (
            <MatchesEvents.NoError/>
        );
    }

    const events = formatter(data?.events?.results);
    if (!loading && events.length === 0) {
        return (
            <MatchesEvents.NoResultsFound/>
        );
    }

    return (
        <ShadowScrollbars onEndReached={handleFetchMore} loading={q !== _q || loading}>
            <Container fluid={true}>
                <Row>
                    {events.map((item, index) =>
                        <Col key={index} xs={12} md={6} lg={4}>
                            <MatchesEvents.Card {...item}/>
                        </Col>)}
                </Row>
            </Container>
        </ShadowScrollbars>
    );
};


MatchesEvents.Loading = props => <div className="w-100 h-100 d-flex justify-content-center align-items-center"><Loading text={"Loading..."} details={"Please wait. While we fetch the data"}/></div>;
MatchesEvents.NoError = props => <div className="w-100 h-100 d-flex justify-content-center align-items-center"><NoError text={"Sorry, Something is broken"} details={"We unable to retrive data at this moment."}/></div>;
MatchesEvents.NoResultsFound = props => <div className="w-100 h-100 d-flex justify-content-center align-items-center"><NoResultFound {...props} /></div>;

MatchesEvents.Card = props => {
    const {title, website, datetime, description, image} = props;
    const websiteDatetimeFormat = `${website} | ${datetime}`;

    return (
        <div className="events-card">
            <Image className="events-card--image" src={image}/>
            <div className="events-card--content">
                <div className="events-card--title"> {title} </div>
                <div className="events-card--website-datetime"> {websiteDatetimeFormat} </div>
                <div className="events-card--description"> {description} </div>
            </div>
        </div>
    );
};

export default MatchesEvents;
